import axios from "axios";
import { config } from "../config";
import { credentials } from "../constants/credentials.constant";
import testResults from "../constants/testResult.constant";

const login = (password: string) => {
  return credentials.includes(password);
};

const getProblem = (problemIdx: number) => {
  const res = "";
  return testResults[problemIdx];
};

const getVideosFromAWS = async (prefix: string) => {
  const res = await axios.get(
    `${config.axios.baseURL}/aws-access.php/?prefix=${prefix}`
  );
  return res;
};

const saveResultScore = async (score: string) => {
  try {
    const res = await axios.post(
      `${config.axios.baseURL}/saveresearchresultscore.php`,
      score
    );
    return true;
  } catch (error) {}
};

const saveMainScore = async (score: string) => {
  try {
    const res = await axios.post(
      `${config.axios.baseURL}/savemainscore.php`,
      score
    );
    return true;
  } catch (error) {}
};

const getIpAddress = async () => {
  try {
    const response = await axios.get("https://geolocation-db.com/json/");
    return response.data.IPv4;
  } catch (error) {}
};

const getUser = async (email: string) => {
  const op = {
    op: "get_user",
    api_key: "810e220b4547df702deeca708f0e896a",
    data: {
      user_email: email,
    },
  };
  const url = `${config.axios.baseURL}/?s2member_pro_remote_op=1`;
  const postData = `s2member_pro_remote_op=${JSON.stringify(op)}`;
  const response = await axios.post(url, postData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return response;
};

export const apiService = {
  login,
  getProblem,
  saveResultScore,
  getIpAddress,
  getUser,
  getVideosFromAWS,
  saveMainScore
};
